import { useEffect, useState } from "react";
import { fetchResultsData } from "../services/api";

const initialState = {
  resultsData: null,
  resultsLoading: false,
  resultsError: null,
};
export const useResultsData = (communeId, year1, year2) => {
  const [state, setState] = useState(initialState);
  useEffect(() => {
    if (!communeId) {
      setState({
        resultsData: null,
        resultsLoading: false,
        resultsError: "Error! Please provide communeId parameter in the url.",
      });
      return;
    }

    setState({ resultsData: null, resultsLoading: true, resultsError: null });

    Promise.all([
      fetchResultsData(communeId, 2017),
      fetchResultsData(communeId, 2023),
    ])
      .then(([resultsData2017, resultsData2023]) => {
        const combinedData = {
          2017: {
            "mhlu-transform": "02/06/2023, 11:01:22",
            results: resultsData2017,
          },
          2023: resultsData2023,
        };
        setState({
          resultsData: combinedData,
          resultsLoading: false,
          resultsError: null,
        });
      })
      .catch((error) => {
        console.error(error);
        setState({
          resultsData: null,
          resultsLoading: false,
          resultsError: "Error fetching Results Data 😔 Please refresh.",
        });
      });
  }, [communeId]);

  return state;
};

// export const useResultsData = (communeId, year) => {
//   const [state, setState] = useState(initialState);

//   useEffect(() => {
//     if (!communeId) {
//       setState({
//         resultsData: null,
//         resultsLoading: false,
//         resultsError: "Error! Please provide communeId parameter in the url.",
//       });
//       return;
//     }

//     setState({ resultsData: null, resultsLoading: true, resultsError: null });

//     fetchResultsData(communeId, year)
//       .then((resultsData) =>
//         setState({
//           resultsData,
//           resultsLoading: false,
//           resultsError: null,
//         })
//       )
//       .catch((error) => {
//         console.error(error);
//         setState({
//           resultsData: null,
//           resultsLoading: false,
//           resultsError: "Error fetching Results Data 😔 Please refresh.",
//         });
//       });
//   }, [communeId, year]);

//   return state;
// };
